import { render, staticRenderFns } from "./ProductOverview.vue?vue&type=template&id=55bad081&scoped=true&"
import script from "./ProductOverview.vue?vue&type=script&lang=js&"
export * from "./ProductOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProductOverview.vue?vue&type=style&index=0&id=55bad081&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bad081",
  null
  
)

export default component.exports